<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    class="area-selecter"
  >
    <template slot="select-header">
      {{ letter.region }}
    </template>
    <template slot="select-content">
      <p class="current-area select-items-popup active">
        {{ curLocation }}
      </p>
      <ul class="area-select-container j-area-select-container">
        <li
          v-for="(area, index) in locations"
          :data-code="area.value"
          @click="selectLocation(area)"
          class="areas-lst select-items-popup j-select-area"
          :pointValue="area.value"
          :key="index"
          v-show="area.name !== curLocation"
        >
          {{ area.name }}
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialWebStore/selectContainer';
import {
  getLocationNameByVal,
  getCurLocation
} from '@store/officialWebStore/storager';
export const HIDE_AREA_SELECTOR = 'hideAreaSelector';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  data() {
    // let curLocationsVal = getCurLocation();
    return {
      curLocation: getLocationNameByVal(this.curLocationsVal)
    };
  },
  props: ['locations', 'curLocationsVal'],
  methods: {
    selectLocation(area) {
      this.curLocation = area.name;
      clickButton({
        btnName: 'select_regions',
        locationKey: locationType.paytypeSection
      });
      this.$emit(HIDE_AREA_SELECTOR, area);
    }
  },
  mixins: [selectContainer]
};
</script>

<style lang="scss" scoped>
.area-selecter {
  z-index: 1002;
}
</style>
